import styles from "./callsInnerLogs.module.scss";
import React, { useEffect } from "react";
import iconincoming from "../../../../styles/images/iconincoming.svg";
import iconmissed from "../../../../styles/images/iconmissed.svg";
import iconoutgoing from "../../../../styles/images/iconoutgoing.svg";
import { Divider, Modal, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { contacts, initialStateModel, LoginState, UserDetails } from "../../../../models/model";
import { useState } from "react";
import {
  boundFrame,
  getTimeFormat,
  timeStampConverter,
  milliSecondsConverter, toastInformation, findTileSize, gotoChat, goCalltoChat
} from "../../../../base/callService/common";
import { URButton } from "../../../../shared/widgets/button";
import {deleteParticularCallLogs, getCallHistoryByExt } from "../../../../base/callService/callsApiService";
import { URCheckBoxCall } from "../../../../shared/widgets/checkbox/callCheckBox";
import { URChatLeftSkeleton } from "../../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import store from "../../../../context/store/store";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import URavatarGroupList from "../../../../shared/widgets/avatarGroupList";
import ProfileAvatarGroup from "../../../chat/leftsidebar/profileavatargroup";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { initiateCall, sendDirectVideoCallRequest } from "../../../../base/callService/callService";
import { useHistory } from "react-router-dom";

type callInnerLogstate = {
  isClearHistory: boolean;
  selectionList: Array<object>;
  isModalVisible: boolean;
  logsOffset: number;
}

export default function CallsInnerLogs() {


  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);
  let { workContacts }: any = store.getState().contactReducer || [];
  let { isHistoryLoading, callHistory ,particularLog} = callReducer;
  const usehistory = useHistory();
  //let { isParticularLoading, particularLog, logs, logsInput, isLogLoading, isHistoryLoading, callHistory } = callReducer;
  
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];

  const [callInnerstate, setCallInnerstate] = useState<callInnerLogstate>
  ({
    isClearHistory: false,
    selectionList: [],
    isModalVisible: false,
    logsOffset:1
  });

  const { isClearHistory,selectionList, isModalVisible,logsOffset } = callInnerstate;
  const openClearLog = () => {
    setCallInnerstate({
      ...callInnerstate,
      isClearHistory: true
    });
  };

  const confirmDelete = () => {
    deleteParticularCallLogs(selectionList);
    closeSelection();
  };
  let { userdetails }: LoginState = store.getState().loginReducer;
  const isDelete = () => {
    (selectionList.length > 0) ?
      (setCallInnerstate({ ...callInnerstate, isModalVisible: true })) :
      toastInformation("No call log selected", "warning");
  };
  const cancelSelection = () => {
    setCallInnerstate({ ...callInnerstate, selectionList: [] });
  };

  const closeSelection = () => {
    setCallInnerstate({
      ...callInnerstate, isClearHistory: false,
      selectionList: [], isModalVisible: false,logsOffset:1
    });
  };
  const selectCallHistory = (data: any, e: any) => {
    if (e.target.checked) { selectionList.push(data?.Uid); }
    else {
      let index = selectionList.indexOf(data?.Uid);
      if (index !== -1) { selectionList.splice(index, 1); }
    }
    setCallInnerstate({...callInnerstate,selectionList:selectionList});
  };
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const selectAll = (e: any) => {
    if (e.target.checked) {
      let allList = callHistory?.map((data: any) => { return data?.Uid; });
      setCallInnerstate({...callInnerstate, selectionList: allList});
    }
    else { cancelSelection(); }
  };

  const handleScroll = (e: any) => {    
    if (!isHistoryLoading) {
      const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
      if (bottom) {
        setCallInnerstate({
          ...callInnerstate, logsOffset: logsOffset + 1
        });
        getCallHistoryByExt(logsOffset + 1);
      }
    }
  };

    useEffect(() => {
      closeSelection();
  }, [particularLog ]);

  const videoMeetTrigger = (data:any) =>{
    if(data?.ext) { 
      sendDirectVideoCallRequest(data);  
  }
    else { toastInformation("Future Implementation","failure"); }
  }
 

  return (
    <>
      <div className={ isClearHistory ? `${styles.logFixed} ${styles.isClear}` : `${styles.logFixed}`}>
        {isClearHistory && < >
          <URCheckBoxCall checked={(selectionList?.length) === (callHistory.length) ? true : false}
            onChange={(e: any) => selectAll(e)} />
          <URButton className='urButton buttonTransparent deleteingbtn'
            name={(selectionList?.length) === (callHistory.length) ? 'Delete All' : 'Delete'}
            onClick={isDelete} />
          <URButton className='urButton buttonTransparent' name='Cancel' onClick={closeSelection} />
        </>}

        {particularLog?.serviceType === 'GroupCall' ?
          <Divider plain className="dividerParticipant">Participants({callHistory.length})</Divider>
          :
          (!isHistoryLoading && !isClearHistory && (callHistory.length) > 0) && <URButton className='urButton buttonTransparent'
            name='Clear Log' onClick={openClearLog} />

        }
      </div>
      {callHistory.length > 0 ?

        <div className={particularLog?.serviceType === 'GroupCall' ? `scroller callfadein ${styles.innerlayerscroll} groupMargin` : `scroller callfadein ${styles.innerlayerscroll}`} onScroll={handleScroll}>
          <>
            {callHistory?.map((history: any, index: any) => {
              let callid: any = workContacts.find((list: any) => list?.ext?.toString() === history?.ext?.toString());

return(
              <div className="Dividerchild" key={index}>
                {history?.callDateTime?.split("T")[0] !== callHistory[index - 1]?.callDateTime?.split("T")[0] &&
                  <Divider plain className="dividerDate">{timeStampConverter(history?.callDateTime, 'group')}</Divider>}
                <div className={isClearHistory ? `${styles.logInnerList} ${styles.isClear}` : `${styles.logInnerList}`}>
                  {isClearHistory && <div className={styles.checkBoxArea}>
                    <URCheckBoxCall checked={selectionList?.indexOf(history?.Uid) > -1 ? true : false}
                      onChange={(e: any) => selectCallHistory(history, e)} />
                  </div>}
                  <div className={styles.logList}>


                    <div className={styles.logIcon}>
                      {particularLog?.serviceType === 'GroupCall' ?
                        <URAvatarGroup
                          className={`lefts size38 one`}
                          profileInfo={<span className={styles.avatarname}>{history?.effective_caller_id_name?.charAt(0).toUpperCase()}</span>}
                        />:

                        <img src={history?.callType === "MISSED" ?
                          iconmissed : history?.callType === "OUTBOUND" ? iconoutgoing : iconincoming} alt="" />}
                    </div>
                    {particularLog?.serviceType === 'GroupCall' ?
                      <div className={styles.logUserName}>
                        {((loggedUser.ext)?.toString() === history?.ext) ? 'You' : history?.effective_caller_id_name}
                        {history?.callType === "OUTBOUND"&&' (host)'}
                      </div> :
                      <div className={styles.logUserName}>
                        {(loggedUser.ext).toString() === history?.calledNo ? history?.callingNo : history?.calledNo}
                      </div>
                    }

                    {particularLog?.serviceType === 'GroupCall' ?
                      <>
                        {(history?.callType === "MISSED") ? 
                          <div className={(history?.callType === "MISSED") ? (`${styles.logStatus} ${styles.missedSts}`) : styles.logStatus}>{boundFrame(history.callType)}</div> :

                          <div className={styles.logDuration}>{milliSecondsConverter(history?.callDuration)}</div>
                        }</> :
                      <>
                        <div className={(history?.callType === "MISSED") ? (`${styles.logStatus} ${styles.missedSts}`) : styles.logStatus}>{boundFrame(history.callType)}</div>
                        <div className={styles.logDuration}>{milliSecondsConverter(history?.callDuration)}</div>
                      </>
                    }
                    {particularLog?.serviceType !== 'GroupCall' && <div className={styles.logTime}>{getTimeFormat(history?.callDateTime)}</div>}
                    {(particularLog?.serviceType === 'GroupCall' && ((history.ext)?.toString() !== (loggedUser.ext)?.toString())) &&
                      <div className={styles.hoverdiv}>
                        <ul>
                          <li onClick={() => initiateCall(history?.ext, 'audio')}><Tooltip placement="top" title="Call" >
                            <span className={styles.iconCall}
                            ></span></Tooltip></li>
                          <li onClick={() => goCalltoChat(callid,usehistory,'')}><Tooltip placement="top" title="Chat">

                            <span className={styles.iconChat} ></span>
                          </Tooltip></li>
                          <li><Tooltip placement="top" title="Meet">
                            <span className={styles.iconMeet}  onClick={()=>videoMeetTrigger(particularLog)}></span></Tooltip></li>
                        </ul>
                      </div>
                    }
                  </div>
                </div>
              </div>
 )} )}
          </>

          {isHistoryLoading &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader}/></div>
          }
        </div>
          :<>{
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25]
              ?.map((item: any, index: any) => (
                <div key={index}><URChatLeftSkeleton/>
                </div>
              ))}
          </>
      }

      <Modal title={(selectionList?.length) === (callHistory.length) ? "Delete all call logs?" :
        "Delete selected call logs?"}
      centered
      visible={isModalVisible}
      onOk={confirmDelete}
      onCancel={closeSelection}
      cancelText="Cancel"
      okText="Delete"
      cancelButtonProps={{ className: 'urButton buttonWhite' }}
      okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        
        {(selectionList?.length) === (callHistory.length) ? "Are you sure you want to delete all call logs?" :
          "Are you sure you want to delete the selected call logs?"}
      </Modal>
    </>
  );
};
